// src/mock/positionStats.js
// 포지션별 2명, 팀 동일(건국대 레이징불스), division=1부
export const mockData = {
  QB: [
    {
      id: 'KKU-QB-01',
      name: '김주전',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'QB',
      games: 8,
      passing_attempts: 230,
      pass_completions: 160,
      completion_percentage: 69.6,
      passing_yards: 2150,
      passing_td: 18,
      interceptions: 6,
      longest_pass: 64,
      sacks: 12,
      rushing_attempts: 42,
      rushing_yards: 210,
      yards_per_carry: 5.0,
      rushing_td: 3,
      longest_rushing: 22,
    },
    {
      id: 'KKU-QB-02',
      name: '이백업',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'QB',
      games: 6,
      passing_attempts: 105,
      pass_completions: 68,
      completion_percentage: 64.8,
      passing_yards: 820,
      passing_td: 6,
      interceptions: 3,
      longest_pass: 45,
      sacks: 9,
      rushing_attempts: 18,
      rushing_yards: 62,
      yards_per_carry: 3.4,
      rushing_td: 0,
      longest_rushing: 11,
    },
  ],

  RB: [
    {
      id: 'KKU-RB-01',
      name: '최러셔',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'RB',
      games: 8,
      rushing_attempts: 165,
      rushing_yards: 980,
      yards_per_carry: 5.9,
      rushing_td: 8,
      longest_rushing: 62,
      rushingFumbles: 2,
      rushingFumblesLost: 1,
      targets: 28,
      receptions: 22,
      receiving_yards: 190,
      yards_per_catch: 8.6,
      receiving_td: 1,
      longest_reception: 30,
      receiving_first_downs: 12,
      passingFumbles: 0,
      passingFumblesLost: 0,
      kick_returns: 6,
      kick_return_yards: 150,
      yards_per_kick_return: 25.0,
      punt_returns: 0,
      punt_return_yards: 0,
      yards_per_punt_return: 0,
      return_td: 0,
    },
    {
      id: 'KKU-RB-02',
      name: '강멀티',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'RB',
      games: 8,
      rushing_attempts: 102,
      rushing_yards: 520,
      yards_per_carry: 5.1,
      rushing_td: 4,
      longest_rushing: 38,
      rushingFumbles: 1,
      rushingFumblesLost: 0,
      targets: 36,
      receptions: 30,
      receiving_yards: 275,
      yards_per_catch: 9.2,
      receiving_td: 2,
      longest_reception: 44,
      receiving_first_downs: 14,
      passingFumbles: 1,
      passingFumblesLost: 1,
      kick_returns: 2,
      kick_return_yards: 42,
      yards_per_kick_return: 21.0,
      punt_returns: 0,
      punt_return_yards: 0,
      yards_per_punt_return: 0,
      return_td: 0,
    },
  ],

  WR: [
    {
      id: 'KKU-WR-01',
      name: '박에이스',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'WR',
      games: 8,
      targets: 108,
      receptions: 84,
      receiving_yards: 1260,
      yards_per_catch: 15.0,
      receiving_td: 12,
      longest_reception: 62,
      receiving_first_downs: 58,
      passingFumbles: 1,
      passingFumblesLost: 0,
      rushing_attempts: 6,
      rushing_yards: 46,
      yards_per_carry: 7.7,
      rushing_td: 1,
      longest_rushing: 16,
      rushingFumbles: 0,
      rushingFumblesLost: 0,
      kick_returns: 8,
      kick_return_yards: 188,
      yards_per_kick_return: 23.5,
      punt_returns: 10,
      punt_return_yards: 120,
      yards_per_punt_return: 12.0,
      return_td: 1,
    },
    {
      id: 'KKU-WR-02',
      name: '윤슬롯',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'WR',
      games: 8,
      targets: 82,
      receptions: 66,
      receiving_yards: 770,
      yards_per_catch: 11.7,
      receiving_td: 5,
      longest_reception: 42,
      receiving_first_downs: 41,
      passingFumbles: 0,
      passingFumblesLost: 0,
      rushing_attempts: 9,
      rushing_yards: 72,
      yards_per_carry: 8.0,
      rushing_td: 0,
      longest_rushing: 20,
      rushingFumbles: 1,
      rushingFumblesLost: 1,
      kick_returns: 2,
      kick_return_yards: 40,
      yards_per_kick_return: 20.0,
      punt_returns: 5,
      punt_return_yards: 40,
      yards_per_punt_return: 8.0,
      return_td: 0,
    },
  ],

  TE: [
    {
      id: 'KKU-TE-01',
      name: '정차단',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'TE',
      games: 8,
      targets: 58,
      receptions: 43,
      receiving_yards: 520,
      yards_per_catch: 12.1,
      receiving_td: 6,
      longest_reception: 31,
      fumbles: 0,
      fumbles_lost: 0,
      rushing_attempts: 4,
      rushing_yards: 18,
      yards_per_carry: 4.5,
      rushing_td: 0,
      longest_rushing: 9,
    },
    {
      id: 'KKU-TE-02',
      name: '문서포트',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'TE',
      games: 8,
      targets: 36,
      receptions: 25,
      receiving_yards: 290,
      yards_per_catch: 11.6,
      receiving_td: 3,
      longest_reception: 27,
      fumbles: 1,
      fumbles_lost: 0,
      rushing_attempts: 2,
      rushing_yards: 7,
      yards_per_carry: 3.5,
      rushing_td: 0,
      longest_rushing: 6,
    },
  ],

  K: [
    {
      id: 'KKU-K-01',
      name: '차정확',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'K',
      games: 8,
      extra_points_attempted: 21,
      extra_points_made: 20,
      field_goal: '12-15',             // 성공-시도
      field_goal_percentage: 80.0,
      field_goal_1_19: 1,
      field_goal_20_29: 4,
      field_goal_30_39: 5,
      fiedl_goal_40_49: 2,              // (오타 키도 함께)
      field_goal_40_49: 2,
      field_goal_50_plus: 0,
      longest_field_goal: 52,
    },
    {
      id: 'KKU-K-02',
      name: '차강킥',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'K',
      games: 8,
      extra_points_attempted: 19,
      extra_points_made: 18,
      field_goal: '10-13',
      field_goal_percentage: 76.9,
      field_goal_1_19: 0,
      field_goal_20_29: 3,
      field_goal_30_39: 5,
      fiedl_goal_40_49: 2,
      field_goal_40_49: 2,
      field_goal_50_plus: 0,
      longest_field_goal: 49,
    },
  ],

  P: [
    {
      id: 'KKU-P-01',
      name: '박롱킥',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'P',
      games: 8,
      punt_count: 34,
      punt_yards: 1460,
      average_punt_yard: 43.0,
      longest_punt: 64,
      touchbacks: 4,
      touchback_percentage: 11.8,
      inside20: 12,
      inside20_percentage: 35.3,
    },
    {
      id: 'KKU-P-02',
      name: '이하늘',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'P',
      games: 8,
      punt_count: 27,
      punt_yards: 1135,
      average_punt_yard: 42.0,
      longest_punt: 58,
      touchbacks: 3,
      touchback_percentage: 11.1,
      inside20: 9,
      inside20_percentage: 33.3,
    },
  ],

  OL: [
    {
      id: 'KKU-OL-01',
      name: '오수호',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'OL',
      offensive_snaps_played: 520,
      penalties: 5,
      sacks_allowed: 3,
    },
    {
      id: 'KKU-OL-02',
      name: '이벽력',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'OL',
      offensive_snaps_played: 505,
      penalties: 6,
      sacks_allowed: 4,
    },
  ],

  DL: [
    {
      id: 'KKU-DL-01',
      name: '마동철',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'DL',
      games: 8,
      tackles: 42,
      TFL: 12,
      sacks: 8.0,
      forced_fumbles: 2,
      fumble_recovery: 1,
      fumble_recovered_yards: 6,
      pass_defended: 3,
      interceptions: 0,
      interception_yards: 0,
      touchdowns: 0,
    },
    {
      id: 'KKU-DL-02',
      name: '허파괴',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'DL',
      games: 8,
      tackles: 36,
      TFL: 9,
      sacks: 6.5,
      forced_fumbles: 1,
      fumble_recovery: 0,
      fumble_recovered_yards: 0,
      pass_defended: 1,
      interceptions: 0,
      interception_yards: 0,
      touchdowns: 0,
    },
  ],

  LB: [
    {
      id: 'KKU-LB-01',
      name: '유주장',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'LB',
      games: 8,
      tackles: 108,
      TFL: 14,
      sacks: 4,
      forced_fumbles: 3,
      fumble_recovery: 2,
      fumble_recovered_yards: 11,
      pass_defended: 8,
      interceptions: 2,
      interception_yards: 39,
      touchdowns: 1,
    },
    {
      id: 'KKU-LB-02',
      name: '한수비',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'LB',
      games: 8,
      tackles: 92,
      TFL: 10,
      sacks: 3,
      forced_fumbles: 2,
      fumble_recovery: 1,
      fumble_recovered_yards: 7,
      pass_defended: 6,
      interceptions: 1,
      interception_yards: 16,
      touchdowns: 0,
    },
  ],

  DB: [
    {
      id: 'KKU-DB-01',
      name: '김스텝',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'DB',
      games: 8,
      tackles: 66,
      TFL: 3,
      sacks: 1,
      forced_fumbles: 2,
      fumble_recovery: 1,
      fumble_recovered_yards: 12,
      pass_defended: 15,
      interceptions: 3,
      interception_yards: 74,
      touchdowns: 1,
      kick_returns: 3,
      kick_return_yards: 72,
      yards_per_kick_return: 24.0,
      punt_returns: 4,
      punt_return_yards: 38,
      yards_per_punt_return: 9.5,
      return_td: 0,
    },
    {
      id: 'KKU-DB-02',
      name: '장커버',
      team: '건국대 레이징불스',
      division: '1부',
      position: 'DB',
      games: 8,
      tackles: 58,
      TFL: 2,
      sacks: 0,
      forced_fumbles: 1,
      fumble_recovery: 1,
      fumble_recovered_yards: 5,
      pass_defended: 10,
      interceptions: 2,
      interception_yards: 45,
      touchdowns: 0,
      kick_returns: 1,
      kick_return_yards: 22,
      yards_per_kick_return: 22.0,
      punt_returns: 2,
      punt_return_yards: 16,
      yards_per_punt_return: 8.0,
      return_td: 0,
    },
  ],
};

// 편하게 쓰라고 평탄화 버전도 함께 제공
export const mockDataFlat = Object.values(mockData).flat();
